import React, { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getTestimonials } from '../lib/api';

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);

  useEffect(() => {
    getTestimonials().then((d) => setItems(d || [])).catch(() => setItems([]));
  }, []);

  const next = useCallback(() => setI((v) => (items.length ? (v + 1) % items.length : 0)), [items.length]);

  useEffect(() => {
    if (items.length < 2) return;
    const id = setInterval(next, 5500);
    return () => clearInterval(id);
  }, [items.length, next]);

  if (!items.length) return null;
  const t = items[i];

  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-40 bg-bone overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-12 text-center">
        <span className="font-sans text-xs uppercase tracking-[0.3em] text-graphite">Client happiness</span>
        <div className="serif text-signal text-[18vw] md:text-[12vw] leading-[0.6] mt-8 select-none">“</div>

        <AnimatePresence mode="wait">
          <motion.div
            key={t.id || i}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
          >
            <blockquote className="serif text-3xl md:text-5xl leading-tight tracking-tight max-w-4xl mx-auto">
              {t.quote}
            </blockquote>
            <div className="mt-10 flex flex-col items-center gap-1">
              <div className="serif italic text-signal text-3xl">{t.result}</div>
              <div className="font-sans text-sm text-obsidian mt-3">{t.author}</div>
              <div className="font-sans text-xs uppercase tracking-[0.2em] text-graphite">{t.role}</div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="flex items-center justify-center gap-3 mt-14">
          {items.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              aria-label={`Testimonial ${idx + 1}`}
              className={`h-2 rounded-full transition-all duration-500 ${
                idx === i ? 'w-8 bg-signal' : 'w-2 bg-black/20'
              }`}
              data-testid={`testimonial-dot-${idx}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
